import {IExecuteMonitoringData} from 'store/slices/documents-uploading-slice';

export const updateTableReportPageRequestDto = (
    data: IExecuteMonitoringData, tableReportPageRequestData: any,
): IExecuteMonitoringData => ({
    ...data,
    table_report_page_request_dto: JSON.stringify(tableReportPageRequestData),
});
